'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productInfoComponent = undefined;

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = require('./../../../common/core/markedRenderer');

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var productInfoComponent = exports.productInfoComponent = {
    template: require('./product-info.html'),
    bindings: {
        product: '<'
    },
    controllerAs: 'vm',
    controller: ["lodash", "certificatesService", function controller(lodash, certificatesService) {
        'ngInject';

        var vm = this;
        vm.hasNotices = hasNotices;
        vm.searchValue = '';
        vm.batchNumberSearch = batchNumberSearch;
        vm.searchByBatchNumber = searchByBatchNumber;
        vm.getCoaUrl = getCoaUrl;
        vm.getMargin = getMargin;
        vm.$onInit = init;

        function hasNotices() {
            return vm.product.mediPimData ? vm.product.mediPimData.faggPublicNotice || vm.product.mediPimData.faggSpecialNotice || vm.product.mediPimData.pharmaPublicNotice || vm.product.mediPimData.pharmaSpecialNotice || vm.product.mediPimData.laboPublicNotice || vm.product.mediPimData.laboSpecialNotice : false;
        }

        function init() {
            if (vm.product.mediPimData) {
                vm.appstores = lodash.filter(vm.product.mediPimData.media, function (i) {
                    return i.type === 1;
                });
                vm.leaflets = lodash.filter(vm.product.mediPimData.media, function (i) {
                    return i.type === 2;
                });
                vm.videos = lodash.filter(vm.product.mediPimData.media, function (i) {
                    return i.type === 3;
                });
                vm.websites = lodash.filter(vm.product.mediPimData.media, function (i) {
                    return i.type === 4;
                });
            }
        }

        function searchByBatchNumber(event) {
            vm.searchValue = event;
        }

        function batchNumberSearch(item) {
            if (vm.searchValue === '' || item.batchNumber && item.batchNumber.toLowerCase().indexOf(vm.searchValue) !== -1) {
                return true;
            }
            return false;
        }

        function getCoaUrl(id) {
            return certificatesService.getCoaUrl(id);
        }

        function getMargin(size) {
            return { "margin-left": +2 * (size - 1) + "em" };
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/product/components/product-info.js
// module id = 974
// module chunks = 0